<template>
	<div>
		<v-row align="stretch">
			<tile-container :size="systemTile.size">
				<component :is="systemTile.component" />
			</tile-container>

			<tile-container :size="communityUsersTile.size" :loading="staff.loading">
				<component
					:is="communityUsersTile.component"
					user-type="Staff"
					:users="staff.items"
				/>
			</tile-container>

			<tile-container
				:size="communityUsersTile.size"
				:loading="resident.loading"
			>
				<component
					:is="communityUsersTile.component"
					user-type="Members"
					:users="resident.items"
				/>
			</tile-container>

			<tile-container :size="communityUsersTile.size" :loading="family.loading">
				<component
					:is="communityUsersTile.component"
					user-type="Guests"
					:users="family.items"
				/>
			</tile-container>
		</v-row>
	</div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

import api from "@/api/cloud";

import { createUser } from "@/store/model/user";

import TileContainer from "./shared/TileContainer";
import { systemTile, communityUsersTile } from "./tiles";

export default {
	components: { TileContainer },

	data: () => ({
		systemTile,
		communityUsersTile,

		staff: {
			loading: false,
			items: [],
		},
		resident: {
			loading: false,
			items: [],
		},
		family: {
			loading: false,
			items: [],
		},
	}),

	computed: {
		...mapGetters({
			community: "session/community",
		}),
	},

	beforeMount() {
		this.load();
	},

	methods: {
		async load() {
			const communityId = this.community.id;
			const types = ["staff", "resident", "family"];
			for (const type of types) this[type].loading = true;

			const users = await api.getAssociationUsers(communityId);


			for (const type of types) {
				this[type].items = _.chain(users).filter(['_type', type]).map(createUser).value();
				console.log(this[type])
				this[type].loading = false;
			}
		},
	},
};
</script>
